import PropTypes from 'prop-types';
import React from 'react';
import { ArrowRightShort } from 'react-bootstrap-icons';

import useTranslation from '../../hooks/use_translation';
import Btn from '../framework/buttons/btn';
import Clickable from '../framework/clickable';
import MarkerThumb from '../test/marker-thumb';
import Trans from '../translation/trans';

const AllergenListItem = ({
	excerpt,
	groups,
	marker_id,
	size = 'md',
	subtitle,
	title,
}) => {
	const { t } = useTranslation('component_allergen_list_item');
	const id_key = `marker-item-${marker_id}`;

	return (
		<Clickable id={id_key}>
			<Btn
				className="clickable py-3"
				color="light"
				component="group_link"
				excerpt={size == 'md' ? <Trans defaults={excerpt} t={t} /> : undefined}
				footnote={subtitle}
				fullWidth
				groups={groups}
				labelType="h3"
				leftSection={
					<MarkerThumb groups={groups} markers={[marker_id]} size={size} />
				}
				marker_id={marker_id}
				page="allergener"
				removePill
				rightSection={<ArrowRightShort className="thumb-sm" />}
				size="md"
				variant="thumb_btn"
				withThumb
			>
				{title}
			</Btn>
		</Clickable>
	);
};

AllergenListItem.propTypes = {
	excerpt: PropTypes.string,
	groups: PropTypes.array,
	marker_id: PropTypes.number,
	size: PropTypes.string,
	subtitle: PropTypes.string,
	title: PropTypes.string,
};

export default AllergenListItem;
